const Payment = require('@/lib/Payments/Payment');
const { toFloat, toInt } = require('@/functions/transform');

/**
 * @constructor
 */
const SubscriptionPayment = function () {
    /**
     * @type {number}
     */
    this.apportionedAmount = null;

    /**
     * @type {number}
     */
    this.ID = null;

    /**
     * @type {number}
     */
    this.numInstallmentsCovered = null;

    /**
     * @type {Payment}
     */
    this.payment = null;
};

SubscriptionPayment.prototype = {
    getHydrationMap() {
        return {
            apportionedAmount: toFloat,
            ID: {
                field: ['ID', 'subscriptionPaymentID'],
                transform: toInt,
            },
            numInstallmentsCovered: toInt,
            payment: {
                field: ['payment', 'payments'],
                model: Payment,
            },
        };
    },
};

module.exports = SubscriptionPayment;
